var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$mq !== 'xs' && _vm.$mq !== 'sm')?_c('div',[_c('el-breadcrumb',{attrs:{"separator":"/"}},_vm._l((_vm.paths),function(path,index){return _c('el-breadcrumb-item',{key:index,attrs:{"to":path.to}},[_vm._v(_vm._s(path.label))])}),1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }